import React from "react";
import "./ContactUs.css";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";
import Announcement from "../../common/Announcement";
import { BsChatSquareTextFill } from "react-icons/bs";
import { FaFacebookF, FaWhatsapp, FaTelegramPlane } from "react-icons/fa";

export default function ContactUs({ globalData, sociallink }) {

  const links = {
    liveChat: sociallink?.liveChat || "#",
    facebook: sociallink?.facebook || "#",
    whatsapp: sociallink?.whatsapp || "#",
    telegram: sociallink?.telegram || "#",
  };

  const handleOpen = (url) => {
    if (!url || url === "#") return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const contactItems = [
    {
      title: "Live Chat",
      subtitle: "",
      url: links.liveChat,
      className: "contact-card-live",
      icon: <BsChatSquareTextFill />,
    },
    {
      title: "Facebook : Facebook Page",
      subtitle: "",
      url: links.facebook,
      className: "contact-card-facebook",
      icon: <FaFacebookF />,
    },
    {
      title: "WhatsApp : Contact Us",
      subtitle: "",
      url: links.whatsapp,
      className: "contact-card-whatsapp",
      icon: <FaWhatsapp />,
    },
    {
      title: "Telegram : Contact Us",
      subtitle: "",
      url: links.telegram,
      className: "contact-card-telegram",
      icon: <FaTelegramPlane />,
    },
  ];

  return (
    <div className="contact-app">
      <Header />

      <div className="contact-page-shell">
        <div className="contact-top-banner">
          <img
            src="../../images/customer.jpg"
            alt="Customer"
            className="contact-top-banner-img"
          />
        </div>

        <div className="contact-announcement-wrap">
          <Announcement globalData={globalData} />
        </div>

        <div className="contact-heading-row">
          <span className="contact-heading-line" />
          <h2>Contact Us</h2>
          <span className="contact-heading-line" />
        </div>

        <div className="contact-list">
          {contactItems.map((item, index) => (
            <button
              key={index}
              type="button"
              className={`contact-card ${item.className}`}
              onClick={() => handleOpen(item.url)}
            >
              <span className="contact-card-icon">{item.icon}</span>
              <span className="contact-card-text">{item.title}</span>
            </button>
          ))}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}